import React, { useState, useEffect } from 'react';
import PeerReviewers from './PeerReviewers';
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";

const PeerReviewersMain = ({reviewersPath, lastUpdated, fetchReviewersPath, removeReviewersPath, reviewerPollingPath, uploadReviewersPath, userToolProps, isPeChannel}) => {
  
  const [lastUpdatedTimestamp, setLastUpdatedTimestamp] = useState(lastUpdated);
  const [reviewersCount, setReviewersCount] = useState(null);

  const renderPeerReviewText = () => {
    if(isPeChannel) {
      return <>
        Channel Screeners can invite Advisers from this list on the corresponding Admin Article page. Advisers can be added while an article is undergoing channel screening, Editor Check and Peer Review. Use this page to manage your list and add additional Advisers individually or via CSV upload. Select the checkbox and click the Delete button to remove reviewers from the list. Select the checkbox and click the Delete button to remove advisers from the list. Remember, Advisers are not considered peer reviewers!
      </>
    } else {
      return <>
            Channel Admins and Channel Curators can invite Advisers from this list on the corresponding Admin Article page. Advisers can be added while an article is in First Channel Preview, Editor Check and Peer Review. Use this page to manage your list and add additional Advisers individually or via CSV upload. Select the checkbox and click the Delete button to remove advisers from the list. Remember, Advisers are not considered peer reviewers!
          </>
    }
  }

  return (
    <Router hashType={"hashbang"}>
      <div className="small-12 columns channel-peer-reviewers-container">
        <div className="row peer-review-header">
          <h1>Internal Adviser List
            {reviewersCount > 0 && <span className="reviewer-h1-blurb reviewers-count">{reviewersCount}</span>}
          </h1>
          {lastUpdatedTimestamp && <span className="header-light-text">Updated on {lastUpdatedTimestamp}</span>}
          <p className="peer-review-description">
            {renderPeerReviewText()}
          </p>
          <br/>
          <p>
            <a href="/author_guide#!/overview/introduction">What’s an Adviser?</a>
          </p>
        </div>
          <Switch>
            <Route path='/' exact>
              <PeerReviewers removeReviewersPath={removeReviewersPath} setLastUpdatedTimestamp={setLastUpdatedTimestamp} setReviewersCount={setReviewersCount} reviewersPath={reviewersPath} fetchReviewersPath={fetchReviewersPath} reviewerPollingPath={reviewerPollingPath} uploadReviewersPath={uploadReviewersPath} userToolProps={userToolProps}/>
            </Route>
          </Switch>
      </div>
    </Router>
  )

}

export default PeerReviewersMain;